import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion as m } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../images/wmLogoUpdate.png";

const Main = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleClick = () => {
      navigate("/discounts");
    };

    toast.info(
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        <center>
          Check out our Family, Active Duty, & College Student DISCOUNTS!
        </center>
      </div>,
      {
        position: "top-center",
        autoClose: 20000,
        theme: "dark",
        toastId: "discounts",
      }
    );
  }, [navigate]);

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <ToastContainer theme="dark" />

      {/* HERO */}
      <section className="min-h-screen flex items-center justify-center bg-black px-4">
        <div className="flex flex-col items-center text-center">
          <m.img
            src={logo}
            alt="Westmore Brazilian Jiu Jitsu"
            className="w-64 md:w-80"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 2.0, ease: "easeOut" }}
          />

          <m.p
            className="mt-4 text-md md:text-base tracking-widest uppercase text-white/80"
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 2.0, delay: 1.0 }}
          >
            Come for the jiu jitsu, stay for the community
          </m.p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="bg-neutral-950 px-4 py-12">
        <div className="max-w-3xl mx-auto bg-black border border-neutral-800 rounded-lg p-6 md:p-10 text-neutral-200">
          <h1 className="text-xl md:text-3xl font-bold mb-4 text-center">
            Westmore Brazilian Jiu Jitsu
          </h1>

          <p className="mb-4">
            Welcome to Westmore Brazilian Jiu Jitsu!
          </p>

          <p className="mb-4">
            At Westmore BJJ, our mission is to foster and build an inclusive
            community for individuals who share a passion for growth and personal
            development. We believe in the power of Brazilian Jiu Jitsu to
            transform lives, and we're dedicated to creating a supportive and
            immersive learning environment where everyone can thrive.
          </p>

          <p className="mb-4">
            Located in the heart of the 805 on the Central Coast, our academy
            offers premier coaching and instruction for individuals of all ages
            and skill levels. Whether you're a child taking your first steps on
            the mat or an adult aiming to compete at the highest level, our
            experienced team is here to guide you on your journey.
          </p>

          <p className="mb-4">
            We believe that Brazilian Jiu Jitsu is more than just a martial art;
            it's a healthy & creative way to express your growth as an individual
            while learning a vital survival skill. Through our comprehensive
            training programs, we empower our members to develop physical
            strength, mental resilience, and unwavering confidence.
          </p>

          <p>
            Join Westmore Brazilian Jiu Jitsu today and experience the
            transformative power of our academy. Start your journey of personal
            growth, build lifelong friendships, and become the best versions of
            ourselves both on and off the mats.
          </p>
        </div>
      </section>
    </m.div>
  );
};

export default Main;
